import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import ToastStack from '../components/ToastStack';

const AppLayout: React.FC = () => (
  <div className="relative min-h-screen bg-slate-100 text-slate-900">
    <ToastStack />
    <div className="flex min-h-screen bg-[radial-gradient(circle_at_top,_#e0f2fe,_#eef2ff_50%,_#f8fafc)]">
      <Sidebar />
      <div className="flex min-h-screen flex-1 flex-col">
        <Header />
        <main className="flex-1 overflow-y-auto p-6 md:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  </div>
);

export default AppLayout;
